import React from "react";
import PropTypes from "prop-types";

export default function Arrow3(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.39062 7.61083C0.99097 7.61083 0.666989 7.93481 0.666989 8.33446C0.666993 8.73411 0.990972 9.05809 1.39062 9.05809L20.8699 9.05809C23.0717 9.05809 23.9167 11.9281 22.0661 13.1212L20.3095 14.2537C19.7841 14.5925 19.7841 15.3608 20.3095 15.6995C20.5932 15.8825 20.9578 15.8825 21.2416 15.6995L24.2671 13.7489C28.2031 11.2113 28.2031 5.45538 24.2671 2.91774L21.2416 0.967145C20.9578 0.78419 20.5932 0.78419 20.3095 0.967145C19.7841 1.30588 19.7841 2.07419 20.3095 2.41292L22.0672 3.54619C23.9185 4.73973 23.0732 7.61083 20.8705 7.61083L1.39062 7.61083Z"
        fill="#063AC9"
      />
    </svg>
  );
}

Arrow3.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

Arrow3.defaultProps = {
  className: "",
  width: 27,
  height: 25
};
